import React from 'react';

import { addContact, deleteContact } from '../../data/serviceClients';

import { showMessage, hideMessage } from '../uiFunctions/uiActions';
import { ActionTabs } from './ActionTabs';
import { InputRow } from './InputRow';

class Contact extends React.Component {
    constructor(props) {
		super(props);
		this.state = {
			contacts: this.props.contacts,
			locations: this.props.locations,
		}
		this.update = this.update.bind(this);
		this.assign = this.assign.bind(this);
		this.updateCrm = this.updateCrm.bind(this);
	}

	add(type) {
		showMessage("Adding New Client...")
		let newContact = {
			"clientCode": this.props.clientCode,
			"type": type,
			"name": "New Contact"
		}
		addContact(newContact).then(data => {
			hideMessage(data.success);
			var newState = this.state.contacts;
			newState.push(data.result);
			this.setState({ contacts: newState });
		});
	}
	addCrm(id) {
		const index = this.state.contacts.findIndex(cont => cont.id === id )
        let newState = this.state.contacts;
        newState[index].crmData.push({"platform":null,"crmId":null,"crmName":null},);

        this.setState({contacts: newState});
	}
    deleteCrm(id, index) {
		const contIndex = this.state.contacts.findIndex(cont => cont.id === id )
        let newState = this.state.contacts;
        newState[contIndex].crmData.splice(index, 1);

        this.setState({contacts: newState});
	}

	update(e) {
		var id = e.target.attributes.customdata.value;
		id = parseInt(id, 10);
		var newState = this.state.contacts
        var index = newState.findIndex(cont => cont.id === id );
		var type = e.target.type;
		var key = e.target.name;
		var value = e.target.value;
		if (type === "checkbox") {
			value = e.target.checked;
		}
		newState[index][key] = value;
		if (key === "firstName" || key === "lastName") {
			newState[index]["name"] = newState[index].firstName+" "+newState[index].lastName;
		}
        this.setState({contacts: newState});
		console.log(newState);
	}
	updateCrm(e) {
        var crmIndex = e.target.attributes.customdata.value;
		crmIndex = parseInt(crmIndex, 10);
        let id = document.querySelectorAll("div#"+this.props.container+"-inputs .tab.active input[name='id']")[0].value;
        id = parseInt(id, 10);
        let contIndex = this.state.contacts.findIndex(cont => cont.id === id );
		var key = e.target.name;
		var value = e.target.value;

        this.setState(state => {
            state.contacts[contIndex].crmData[crmIndex][key] = value
            return state
        });
    }

	isAssigned(id, list) {
		var checked = false;
		if (list.includes(id)) {
			checked = true;
		}
		return checked;
	}
	assign(e) {
		var newState = this.state.contacts;
		 console.log(newState);

		var locId = parseInt(e.target.id, 10);
		var contId = parseInt(e.target.attributes.customdata.value, 10);
		var index = newState.findIndex(cont => cont.id === contId );
		 console.log(locId, contId, index);

		var checked = e.target.checked
		 console.log(checked)
		
		if (checked) { newState[index].locations.push(locId); }
		else {newState[index].locations = newState[index].locations.filter(loc => { return loc !== locId });}
	}

	updateContacts(action, container) {
		var newState = this.state.contacts;
		var contId = parseInt(document.querySelectorAll("div#"+container+"-inputs .tab.active input[name='id']")[0].value, 10);
		var index = newState.findIndex(cont => cont.id === contId );
		var contact = this.state.contacts[index];
		contact["name"] = contact.firstName + " " + contact.lastName;

		if (action === "delete") {
			var strconfirm = window.confirm("Are you sure you want to delete?");
			if (strconfirm === true) {
				showMessage("Deleting Contact...");
				deleteContact(contact.id).then(response => {
					if (response.success) {
						newState = newState.filter(cont => { return cont !== contact});
						this.setState({contacts: newState});
					}
					hideMessage(response.success);
				});
			} else {
				return;
			}
		} else {
			showMessage("Saving Contact...");
			console.log(contact);
			addContact(contact).then(response => {
				hideMessage(response.success)
				console.log(response);
			});
		}
	}

    render() {
        const { contacts, locations } = this.state;
        const type = this.props.type;
        const container = this.props.container;

        return(
            <div>
                <ActionTabs
                    handleAdd={() => this.add(type)}
                    handleSave={() => this.updateContacts("save", container)}
                    handleDelete={() => this.updateContacts("delete", container)}
                    id={container}
                    tabs={contacts}
                />
                <div id={container+"-inputs"} className="inputs">
                    {(contacts.map((contact) =>
                        (<React.Fragment key={contact.id}>
                            <div id={container+"-"+contact.id} className={"tab "+container+"-"+contact.id}>
                                <input type="hidden" name="id" value={contact.id} hidden="hidden" />
                                <input type="hidden" name="clientCode" value={contact.clientCode} hidden="hidden" />
                                <input type="hidden" name="onSite" value="" hidden="hidden" />
                                {(container === "billing-contact") && (
                                    <input type="hidden" name="type" value={contact.type} hidden="hidden" />
                                )}
                                <InputRow onChange={this.update} data={contact.id} label="First Name" type="text" value={contact.firstName} property="firstName" />
                                <InputRow onChange={this.update} data={contact.id} label="Last Name" type="text" value={contact.lastName} property="lastName" />
                                <InputRow onChange={this.update} data={contact.id} label="Job Title" type="text" value={contact.type} property="type" />
                                <InputRow onChange={this.update} data={contact.id} label="Email" type="text" value={contact.email} property="email" />
                                <InputRow onChange={this.update} data={contact.id} label="Business Phone" type="text" value={contact.phone} property="phone" />
                                <InputRow onChange={this.update} data={contact.id} label="Mobile Phone" type="text" value={contact.mobilePhone} property="mobilePhone" />
                                <InputRow onChange={this.update} data={contact.id} label="Notes" type="text" value={contact.notes} property="notes" />
								{(container === "contact") && (
									<React.Fragment>
										<h4>Misc Settings</h4>
										<InputRow onChange={this.update} data={contact.id} label="Use As Accessibility Contact on Site" type="checkbox" value={contact.accessibility} property="accessibility" />										
										<InputRow onChange={this.update} data={contact.id} label="Use As Default Sales Rep for Client" type="checkbox" value={contact.defaultRep} property="defaultRep" />
										<h4>Lead Settings</h4>
										<InputRow onChange={this.update} data={contact.id} label="Receive Lead Email Notifications?" type="checkbox" value={contact.receiveLeadEmail} property="receiveLeadEmail" description="will receive leads from all locations, unless specified below." />
										<InputRow onChange={this.update} data={contact.id} label="Receive Lead SMS Notifications?" type="checkbox" value={contact.receiveLeadSms} property="receiveLeadSms" description="will receive SMS from all locations, unless specified below." />
										<InputRow onChange={this.update} data={contact.id} label="Receive Lead Error Notifications?" type="checkbox" value={contact.receiveErrors} property="receiveErrors" description="will receive lead error notifications from all locations, unless specified below." />

										{(locations && (contact.receiveLeadSms || contact.receiveLeadEmail)) && (
											<React.Fragment>
												<p>To receive leads from only select locations, choose them below.</p>
												<table>
													<thead>
														<tr>
															<th>Id</th>
															<th>Name</th>
															<th>City</th>
															<th>State</th>
														</tr>
													</thead>
													<tbody>
														{locations.map(location =>
															<tr key={location.id}>
																<td>
																<input type="checkbox" id={location.id} customdata={contact.id} onChange={this.assign} defaultChecked={this.isAssigned(location.id, contact.locations)} />
																</td>
																<td>{location.name}</td>
																<td>{location.city}</td>
																<td>{location.state}</td>
															</tr>
														)}
													</tbody>
												</table>
											</React.Fragment>
										)}

                                        <h4>CRM Connections</h4>
                                        <div className="tabs-wrapper">
                                            <ActionTabs
                                                handleAdd={() => this.addCrm(contact.id)}
                                            />
                                        </div>
                                        {(contact.crmData) && (
                                            contact.crmData.map((crm, index) =>
                                                <div className="" key={index} >
                                                    <div className="delete"><i className="far fa-trash-alt icon" onClick={() => this.deleteCrm(contact.id, index)}></i></div>
                                                    <InputRow
                                                        label="Platform"
                                                        type="select"
                                                        value={crm.platform}
                                                        property="platform"
                                                        id="platform"
                                                        hideSelectOption="false"
                                                        options={[ //list of CRMs from credentials.. maybe move to helpers eventually
															{ "name": "CRM - Builder Prime", "value": "builderPrime"},
															{ "name": "CRM - Hubspot", "value": "hubspot"},
															{ "name": "CRM - Pacific Solutions", "value": "pacsol"},
															{ "name": "CRM - QFloors", "value": "qfloors"},
															{ "name": "CRM - RFMS", "value": "rfms"},
															{ "name": "CRM - RLM", "value": "rlm"},
                                                            { "name": "CRM - Rollmaster", "value": "rollmaster"},
                                                            { "name": "CRM - Sharp Spring", "value": "sharpSpring"},
															{ "name": "CRM - vTiger", "value": "vtiger"},
															{ "name": "CRM - Zendesk", "value": "zendesk"},
                                                            { "name": "CRM - Zendesk Sell", "value": "zendeskSell"}
                                                        ]}
                                                        onChange={this.updateCrm}
                                                        data={index}
                                                    />
                                                    <InputRow onChange={this.updateCrm} data={index} label="ID" type="text" value={crm.crmId} property="crmId" />
                                                    <InputRow onChange={this.updateCrm} data={index} label="Name" type="text" value={crm.crmName} property="crmName" />
                                                </div>
                                            )
                                        )}
									</React.Fragment>
                                )}
                                
                            </div>
                        </React.Fragment>)
                    ))}
                </div>
            </div>
        )
    }
}
export default Contact;


// WEBPACK FOOTER //
// ./src/helpers/uiComponents/Contact.js